import styled from 'styled-components';
import { PlainIconButton, iconButtonSizeConfig } from '../../fuse-buttons/src/buttons';
import { Icon as IconElement } from '../../fuse-icon-element/src/icon-element';
import { gridConfig } from '../../fuse-responsive-grid/src/grid';
import { convertRemToPx, defaultCssProps } from '../../fuse-typography/src/typography';
import { TypographyComponent } from '../../fuse-typography-element/src/typography';

const modalHeadingHeight = convertRemToPx(defaultCssProps?.t3?.lineHeight);
const headerButtonHeight = iconButtonSizeConfig.small?.iconHeight?.replace('px', '');
const iconAndButtonMarginTop = `${(modalHeadingHeight - headerButtonHeight) / 2}px`;

const StyledModalHeader = styled.div.attrs({
	className: 'fuse-modal__header',
	'data-testid': 'fuse-modal__header',
})`
	${({ hasDepth }) => `
		align-items: center;
		background-color: var(--color-functional-panelLight);
		border-bottom: 1px solid var(--color-functional-divider);
        border-top-left-radius: inherit;
        border-top-right-radius: inherit;
		color: var(--color-global-black);
		display: flex;
        flex-shrink: 0; /* Required for safari mobile ios < 14.7 so that modal header height isn't shrink and adjusts dynamically to its content */
		left: 0;
		padding: ${gridConfig.xxs.margin};
		top: 0;
		transition: box-shadow 50ms ease-in-out;
		width: 100%;
		z-index: 1;

		${
	hasDepth
		? `
						box-shadow: var(--elevation-shadow-l);
				  `
		: ``
}

		@media only screen and (min-width: ${gridConfig.m.minWidth}) {
			padding: ${gridConfig.m.margin};
			${
	hasDepth
		? `
							box-shadow: var(--elevation-shadow-xl);
					  `
		: ``
}
		}

        @media only screen and (min-width: ${gridConfig.xl.minWidth}) {
			${
	hasDepth
		? `
							box-shadow: var(--elevation-shadow-xxl);
					  `
		: ``
}
		}
	`}
`;

const StyledModalBackButton = styled(PlainIconButton).attrs({
	className: 'fuse-modal__back-button',
	'data-testid': 'fuse-modal__back-button',
})`
	margin-top: ${iconAndButtonMarginTop};
`;

const StyledModalHeadingIcon = styled(IconElement).attrs({
	className: 'fuse-modal__header-icon',
	'data-testid': 'fuse-modal__header-icon',
})`
	margin-top: ${iconAndButtonMarginTop};
`;

const StyledModalHeading = styled(TypographyComponent).attrs({
	className: 'fuse-modal__heading',
	'data-testid': 'fuse-modal__heading',
})`
	${({ hasBackButton, headerIcon }) => `
		flex: 1 1 auto;
		${hasBackButton || headerIcon ? `margin-left: var(--spacing-global-space3);` : ``}
	`}
`;

const StyledModalCloseButton = styled(PlainIconButton).attrs({
	className: 'fuse-modal__close-button',
	'data-testid': 'fuse-modal__close-button',
})`
	margin-left: var(--spacing-global-space3);
	margin-top: ${iconAndButtonMarginTop};
`;

export {
	StyledModalHeader,
	StyledModalHeading,
	StyledModalHeadingIcon,
	StyledModalBackButton,
	StyledModalCloseButton,
};
